import React, { FC, ReactElement } from 'react';

import * as RadixDropdownMenu from '@radix-ui/react-dropdown-menu';
import clsx from 'clsx';

import styles from './DropdownMenu.module.scss';

export type DropdownMenuSide = 'top' | 'right' | 'bottom' | 'left';
export type DropdownMenuAlign = 'center' | 'start' | 'end';

type Props = {
  trigger: ReactElement;
  content: ReactElement;
  topSlot?: ReactElement;
  side?: DropdownMenuSide;
  align?: DropdownMenuAlign;
  sideOffset?: number;
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
  modal?: boolean;
  preventFocusSteal?: boolean;
  contentClassName?: string;
};

export const DropdownMenu: FC<Props> = ({
  trigger,
  content,
  topSlot,
  side = 'bottom',
  align = 'center',
  sideOffset = 4,
  open,
  onOpenChange,
  modal = true,
  preventFocusSteal = false,
  contentClassName,
}) => {
  return (
    <RadixDropdownMenu.Root
      open={open}
      onOpenChange={onOpenChange}
      modal={modal}
    >
      <RadixDropdownMenu.Trigger asChild>{trigger}</RadixDropdownMenu.Trigger>

      <RadixDropdownMenu.Portal>
        <RadixDropdownMenu.Content
          className={clsx(styles.menu, contentClassName)}
          side={side}
          align={align}
          sideOffset={sideOffset}
          onCloseAutoFocus={(event): void => {
            if (preventFocusSteal) {
              event.preventDefault();
            }
          }}
          {...({
            onOpenAutoFocus: (event: Event): void => {
              if (preventFocusSteal) {
                event.preventDefault();
              }
            },
          } as Record<string, unknown>)}
        >
          {topSlot ? <div className={styles.top_slot}>{topSlot}</div> : null}
          {content}
        </RadixDropdownMenu.Content>
      </RadixDropdownMenu.Portal>
    </RadixDropdownMenu.Root>
  );
};
